import { render, staticRenderFns } from "./CommandeTeamPerformance.vue?vue&type=template&id=0165dd8a&scoped=true"
import script from "./CommandeTeamPerformance.vue?vue&type=script&lang=js"
export * from "./CommandeTeamPerformance.vue?vue&type=script&lang=js"
import style0 from "./CommandeTeamPerformance.vue?vue&type=style&index=0&id=0165dd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0165dd8a",
  null
  
)

export default component.exports